import satokoi from "./assets/art/satokoi.jpg";
import alice from "./assets/art/Alice.jpg";
import cirno from "./assets/art/cirno.jpg";
import hinatori from "./assets/art/hinatori.jpg";
import kaguya from "./assets/art/kaguya.jpg";
import mokou from "./assets/art/mokou.jpg";
import okuu from "./assets/art/okuu.jpg";
import suwa from "./assets/art/suwa.jpg";
import yuyuchoco from "./assets/art/yuyuchoco.jpg";
import yuyukari from "./assets/art/yuyukari.jpg";
import yuyuko from "./assets/art/yuyuko.jpg";
import pcb from "./assets/art/pcb.jpg";
import cirnorabbits from "./assets/art/cirnorabbits.png";
import yukariyuyumanga from "./assets/art/yukariyuyumanga.jpg";
import kutaka from "./assets/art/kutaka.jpg";
import chennailspr from "./assets/art/chennailspr.png";
import ganchen from "./assets/art/ganchen.png";
import raiden from "./assets/art/raiden.png";
import scarapleadingface from "./assets/art/scarapleadingface.png";
import valentines from "./assets/art/valentines.png";
import myshheart from "./assets/art/myshheart.png";
import zanmu from "./assets/art/zanmu.png";
import art127217959 from "./assets/art/127217959_p0.png";
import art127568971 from "./assets/art/127568971_p0.png";
import art130233166 from "./assets/art/130233166_p0.png";
import art135303778 from "./assets/art/135303778_p0.png";
import art136892284 from "./assets/art/136892284_p0.png";
import art137179390 from "./assets/art/137179390_p0.png";
import art141467182 from "./assets/art/141467182_p0.png";
import art141511598 from "./assets/art/141511598_p0_master1200.jpg";
import art143840517 from "./assets/art/143840517_p0.jpg";

import th7 from "./assets/twc-art/th07_survival.png";
import th9 from "./assets/twc-art/th09_scoring.png";
import th10 from "./assets/twc-art/th10_survival.png";
import th16 from "./assets/twc-art/th16_survival.png";
import th16sc from "./assets/twc-art/th16_scoring.png";
import yuyu from "./assets/twc-art/yuyuko.jpg";

import yuyuHype from "./assets/twitch-emotes/yuyuhype.png";
import yuyuCry from "./assets/twitch-emotes/cryemote.png";
import yuyuScared from "./assets/twitch-emotes/emotescare.png";
import emote141144580 from "./assets/twitch-emotes/141144580_p0.png";

import season1 from "./assets/4 seasons/124434252_p0.png";
import season2 from "./assets/4 seasons/126510866_p0.png";
import season3 from "./assets/4 seasons/129285310_p0.png";
import season4 from "./assets/4 seasons/134446841_p0.png";

import osuFanart from "./assets/osu/142912307_p0_master1200.jpg";

import m1 from "./assets/manga/m1.jpg";
import m2 from "./assets/manga/m2.jpg";
import m3 from "./assets/manga/m3.jpg";
import m4 from "./assets/manga/m4.jpg";
import m5 from "./assets/manga/m5.jpg";
import m6 from "./assets/manga/m6.jpg";
import m7 from "./assets/manga/m7.jpg";
import m8 from "./assets/manga/m8.jpg";
import m9 from "./assets/manga/m9.jpg";

import twitch from "./assets/icons/twitch.png";

export const regularArt = [
  satokoi,
  alice,
  cirno,
  hinatori,
  kaguya,
  mokou,
  okuu,
  suwa,
  yuyuchoco,
  yuyukari,
  yuyuko,
  pcb,
  cirnorabbits,
  yukariyuyumanga,
  kutaka,
  chennailspr,
  ganchen,
  myshheart,
  raiden,
  scarapleadingface,
  valentines,
  zanmu,
  art127217959,
  art127568971,
  art130233166,
  art135303778,
  art136892284,
  art137179390,
  art141467182,
  art141511598,
  art143840517,
];

export const twcArt = [
  { image: th7, scaleDownOptions: "" },
  { image: th10, scaleDownOptions: "" },
  { image: th16, scaleDownOptions: "" },
  { image: th16sc, scaleDownOptions: "" },
  { image: th9, scaleDownOptions: "" },
  { image: yuyu, scaleDownOptions: "" },
];

export const twitchEmotes = [yuyuHype, yuyuScared, yuyuCry, emote141144580];

export const manga = [m1, m2, m3, m4, m5, m6, m7, m8, m9];

export const fourSeasonsArt = [season1, season2, season3, season4];

export { twitch, osuFanart };
